module.exports = __webpack_public_path__ + "img/zoomi.1a435dcf.jpg";